<div class="py-24 sm:py-32">
  <div class="mx-auto max-w-7xl px-6 lg:px-8">
    <div class="mx-auto max-w-2xl space-y-16 lg:mx-0 lg:max-w-none">
      <!-- Section Header -->
      <div class="text-center" @fadeIn>
        <h2 class="text-base font-semibold leading-7 text-indigo-600">
          {{ 'contact.title' | translate }}
        </h2>
        <p class="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          {{ 'contact.heading' | translate }}
        </p>
        <p class="mt-6 text-lg leading-8 text-gray-600">
          {{ 'contact.description' | translate }}
        </p>
      </div>

      <div class="grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-3">
        <!-- Contact Information -->
        <div @fadeIn>
          <h3 class="text-2xl font-bold tracking-tight text-gray-900">
            {{ 'contact.info.title' | translate }}
          </h3>
          <p class="mt-4 leading-7 text-gray-600">
            {{ 'contact.info.description' | translate }}
          </p>

          <div class="mt-8 space-y-4" @staggerItems>
            <div class="flex gap-x-4">
              <div class="flex-none">
                <span class="sr-only">Telephone</span>
                <svg class="h-7 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                </svg>
              </div>
              <div>
                <a dir="ltr" class="hover:text-indigo-600" [href]="'tel:' + ('contact.info.phone' | translate)">
                  {{ 'contact.info.phone' | translate }}
                </a>
              </div>
            </div>

            <div class="flex gap-x-4">
              <div class="flex-none">
                <span class="sr-only">Email</span>
                <svg class="h-7 w-6 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                </svg>
              </div>
              <div>
                <a class="hover:text-indigo-600" [href]="'mailto:' + ('contact.info.email' | translate)">
                  {{ 'contact.info.email' | translate }}
                </a>
              </div>
            </div>
          </div>

          <!-- Social Links -->
          <div class="mt-10">
            <h4 class="text-lg font-semibold text-gray-900">{{ 'contact.social.title' | translate }}</h4>
            <div class="mt-4 flex gap-x-5">
              <a href="https://www.instagram.com/qootk.om" class="text-gray-400 hover:text-indigo-600">
                <span class="sr-only">{{ 'contact.social.instagram' | translate }}</span>
                <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fill-rule="evenodd"
                    d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                    clip-rule="evenodd" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <!-- Contact Form -->
        <div class="lg:col-span-2" @formAnimation>
          <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
            <div class="px-6 py-6 sm:p-8">
              <div class="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
                <!-- First Name Field -->
                <div>
                  <label for="FirstName" class="block text-sm font-semibold leading-6 text-gray-900">{{ 'contact.form.first_name' | translate }}</label>
                  <div class="mt-2.5">
                    <input type="text" id="FirstName" formControlName="FirstName"
                      class="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    <div *ngIf="contactForm.get('FirstName')?.invalid && contactForm.get('FirstName')?.touched"
                      class="mt-1 text-sm text-red-600">
                      {{ 'contact.form.validation.first_name_required' | translate }}
                    </div>
                  </div>
                </div>

                <!-- Last Name Field -->
                <div>
                  <label for="LastName" class="block text-sm font-semibold leading-6 text-gray-900">{{ 'contact.form.last_name' | translate }}</label>
                  <div class="mt-2.5">
                    <input type="text" id="LastName" formControlName="LastName"
                      class="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    <div *ngIf="contactForm.get('LastName')?.invalid && contactForm.get('LastName')?.touched"
                      class="mt-1 text-sm text-red-600">
                      {{ 'contact.form.validation.last_name_required' | translate }}
                    </div>
                  </div>
                </div>

                <!-- Email Field -->
                <div>
                  <label for="Email" class="block text-sm font-semibold leading-6 text-gray-900">{{ 'contact.form.email' | translate }}</label>
                  <div class="mt-2.5">
                    <input type="email" id="Email" formControlName="Email"
                      class="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    <div *ngIf="contactForm.get('Email')?.invalid && contactForm.get('Email')?.touched"
                      class="mt-1 text-sm text-red-600">
                      {{ 'contact.form.validation.email_required' | translate }}
                    </div>
                  </div>
                </div>

                <!-- Mobile Field -->
                <div>
                  <label for="Mobile" class="block text-sm font-semibold leading-6 text-gray-900">{{ 'contact.form.mobile' | translate }}</label>
                  <div class="mt-2.5">
                    <input type="tel" id="Mobile" formControlName="Mobile" placeholder="{{ 'contact.form.mobile_placeholder' | translate }}"
                      class="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    <div *ngIf="contactForm.get('Mobile')?.invalid && contactForm.get('Mobile')?.touched"
                      class="mt-1 text-sm text-red-600">
                      {{ 'contact.form.validation.mobile_required' | translate }}
                    </div>
                  </div>
                </div>

                <!-- Company Name Field -->
                <div>
                  <label for="CompanyName" class="block text-sm font-semibold leading-6 text-gray-900">{{ 'contact.form.company_name' | translate }}</label>
                  <div class="mt-2.5">
                    <input type="text" id="CompanyName" formControlName="CompanyName"
                      class="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    <div *ngIf="contactForm.get('CompanyName')?.invalid && contactForm.get('CompanyName')?.touched"
                      class="mt-1 text-sm text-red-600">
                      {{ 'contact.form.validation.company_required' | translate }}
                    </div>
                  </div>
                </div>

                <!-- Branch Number Field -->
                <div>
                  <label for="BranchNum" class="block text-sm font-semibold leading-6 text-gray-900">{{ 'contact.form.branch_num' | translate }}</label>
                  <div class="mt-2.5">
                    <input type="number" id="BranchNum" formControlName="BranchNum" min="1"
                      class="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    <div *ngIf="contactForm.get('BranchNum')?.invalid && contactForm.get('BranchNum')?.touched"
                      class="mt-1 text-sm text-red-600">
                      {{ 'contact.form.validation.branch_required' | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Submit Button -->
            <div class="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-6 py-4">
              <button type="submit" [disabled]="contactForm.invalid || isSubmitting"
                class="rounded-md bg-indigo-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-50">
                <span *ngIf="!isSubmitting">{{ 'contact.form.submit' | translate }}</span>
                <span *ngIf="isSubmitting">{{ 'contact.form.sending' | translate }}</span>
              </button>
            </div>
          </form>

          <!-- Success Message -->
          <div *ngIf="submitted" class="mt-6 rounded-md bg-green-50 p-4">
            <div class="flex">
              <div class="flex-shrink-0">
                <svg class="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                    clip-rule="evenodd" />
                </svg>
              </div>
              <div class="ml-3">
                <p class="text-sm font-medium text-green-800">
                  {{ 'contact.form.success' | translate }}
                </p>
              </div>
            </div>
          </div>

          <!-- Error Message -->
          <div *ngIf="submitError" class="mt-6 rounded-md bg-red-50 p-4">
            <div class="flex">
              <div class="flex-shrink-0">
                <svg class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z"
                    clip-rule="evenodd" />
                </svg>
              </div>
              <div class="ml-3">
                <p class="text-sm font-medium text-red-800">
                  {{ 'contact.form.error' | translate }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
